import React, { useEffect } from "react";
import { formatStakeBalance, getPackageIcon, getStakingTypeLabel } from "./stakingStakeHelpers";
import "./staking.css";

const StakeSuccessPopup = ({ selectedPackage, stakeAmount, isTopUp = false, onDone }) => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onDone?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onDone]);

  if (!selectedPackage) return null;

  const currency = selectedPackage.currency || "";
  const currencyFullName = selectedPackage.currencyFullName || selectedPackage.fullName || "";
  const duration = selectedPackage.duration ?? selectedPackage.durationDays;
  const apr = selectedPackage.returnPercentage ?? "—";
  const stakingType = getStakingTypeLabel(selectedPackage.stakingType);
  const durationLabel = duration != null ? `${duration} Days` : null;

  return (
    <div className="stake-success-overlay" onClick={onDone}>
      <div className="stake-success-content" onClick={(e) => e.stopPropagation()}>
        <div className="stake-success-icon" aria-hidden="true">
          <i className="ri-checkbox-circle-fill" />
        </div>
        <h3 className="stake-success-title">
          {isTopUp ? "Staking Successful!" : "Staking Successful!"}
        </h3>
        <p className="stake-success-message">
          {isTopUp ? (
            <>
              You have successfully added{" "}
              <strong>{formatStakeBalance(stakeAmount)} {currency}</strong> to your staking position.
            </>
          ) : (
            <>
              You have successfully staked{" "}
              <strong>{formatStakeBalance(stakeAmount)} {currency}</strong> in this package.
            </>
          )}
        </p>

        <div className="stake-success-package">
          <img
            src={getPackageIcon(selectedPackage)}
            alt={currency}
            className="stake-success-package__icon"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = `/images/staking_img/${String(currency || "usdt").toLowerCase()}_icon.svg`;
            }}
          />
          <div className="stake-success-package__info">
            <span className="stake-success-package__name">
              {currency}
              {currencyFullName ? ` (${currencyFullName})` : ""}
            </span>
            <span className="stake-success-package__meta">
              {[stakingType, durationLabel, apr !== "—" ? `${apr}% APR` : null].filter(Boolean).join(" · ")}
            </span>
          </div>
        </div>

        <button type="button" className="mint-btn-confirm stake-success-btn" onClick={onDone}>
          Done
        </button>
      </div>
    </div>
  );
};

export default StakeSuccessPopup;
